import logo from '../images/FullLogo_Transparent_NoBuffer.png';

const NavBar = () => {
    return (
        <nav className="navbar navbar-expand-lg">
            <div className="container-fluid">
                <a className="navbar-brand" href="#intro">
                    <img src={logo} width={225} alt="Watcher" />
                </a>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarTogglerDemo02" aria-controls="navbarTogglerDemo02" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarTogglerDemo02">
                    <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                        <li className="nav-item">
                            <a className="nav-link" href="#overview-section">Overview</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="#pricing-section">Pricing</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href='#contact-section'>Contact</a>
                        </li>
                    </ul>
                    <form className="d-flex">
                        <a className="nav-link" href="/login">Login</a>
                        <a className="nav-link" href="/signup">Sign Up</a>
                    </form>
                </div>
            </div>
        </nav>
    )
}

export default NavBar;